import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { theme } from 'antd';
import { GoBackButtonProps } from 'store/ducks/Global/types';
import * as Styled from './GoBackButton.styled';

const { useToken } = theme;

const GoBackButton: React.FC<GoBackButtonProps> = ({ to, text, goBack }) => {
  const navigate = useNavigate();
  const { token } = useToken();
  const location = useLocation();

  const handleClick = () => {
    if (goBack) {
      if (location.state?.from) {
        navigate(-1);
      } else if (location.pathname.startsWith('/data_entry/')) {
        navigate('/data_entry');
      } else if (location.pathname.startsWith('/dashboard/')) {
        navigate('/dashboard');
      } else {
        navigate('/working_area');
      }
    }
  };

  if (goBack) {
    return (
      <Styled.StyledGoBackButton
        type="primary"
        onClick={handleClick}
        token={token}
      >
        {text}
      </Styled.StyledGoBackButton>
    );
  }

  return (
    <Styled.StyledLink to={to || '#'}>
      <Styled.StyledGoBackButton type="primary" token={token}>
        {text}
      </Styled.StyledGoBackButton>
    </Styled.StyledLink>
  );
};

export default GoBackButton;
